<template>
  <div class="toggle-button square" @click="toggle" :class="{ 'active': value, 'disabled': disabled }">
    <slot />
  </div>
</template>

<script>

export default {
  name: "BigToggleButton",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("input", !this.value); // Émet "input" pour mettre à jour v-model
      this.$emit("change", !this.value); // Émet "change" pour les autres actions
    },
  },
};
</script>

<style scoped>

.toggle-button.active {
  background-color: white;
  color: black;
}

.toggle-button:hover:not(.disabled) {
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.4);
}

.toggle-button.disabled {
  background-color: #dee2e6;
  color: #8a909c;
  cursor: not-allowed;
}

.toggle-button.disabled:hover {
  background-color: #dee2e6;
}

.toggle-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 10px;
  width: 20px;
  height: 20px;
  border: 2px solid #436f0e;
  background-color: transparent;
  border-radius: 4px; /* carré avec coins légèrement arrondis */
  transform: translate(0, -50%);
  transition: 0.3s;
  box-sizing: border-box;
}

.toggle-button.active::before {
  background-color: #436f0e;
  border-color: #436f0e;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;
}
</style>
